var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusSquared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 0H23.1667C23.9031 0 24.5 0.59696 24.5 1.33333V22.6667C24.5 23.4031 23.9031 24 23.1667 24H1.83333C1.09696 24 0.5 23.4031 0.5 22.6667V1.33333C0.5 0.59696 1.09696 0 1.83333 0ZM3.16667 2.66667V21.3333H21.8333V2.66667H3.16667ZM11.1667 10.6667V5.33333H13.8333V10.6667H19.1667V13.3333H13.8333V18.6667H11.1667V13.3333H5.83333V10.6667H11.1667Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquared);
export default __webpack_public_path__ + "static/media/PlusSquared.98e0c6eccdfde06a1ff4c8476c2a0a3b.svg";
export { ForwardRef as ReactComponent };